module.exports = __webpack_public_path__ + "static/media/scene8_sama1.11f330d4.wav";